module.exports = __webpack_public_path__ + "img/lima.f2459baf.jpg";